import React from "react";
import Avatar from "@/components/Avatar";
import SpeechBubble from "@/components/SpeechBubble";
import WeatherFx from "@/components/WeatherFx";
import CoverPassOffer from "@/components/CoverPassOffer";
import RiceBallButton from "@/components/RiceBallButton";
import { activeAccessory } from "@/lib/milestones";
import { getMochiMomentum } from "@/lib/mochiMeter";

// The Mochi "hero" block: avatar (with dark-mode halo + ambient weather),
// speech bubble, cover-pass offer card, and the rice-ball feed button.
export default function MochiHero({
    avatarRef, mood, settings, setSettings, skin, animateSkinIn,
    fireDance, onFireDance, idleGaze,
    coverOffer, onAcceptCover, onDeclineCover,
}) {
    return (
        <div className="mt-2 flex flex-col items-center">
            <div ref={avatarRef} className="relative">
                {/* Soft warm halo behind Mochi — visible only in dark mode so the
                    avatar reads against the inky background instead of floating. */}
                <div
                    aria-hidden="true"
                    className="pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[280px] h-[280px] rounded-full blur-3xl opacity-0 dark:opacity-70 transition-opacity duration-500 bg-mustard-soft/70"
                    data-testid="avatar-dark-glow"
                />
                {/* Ambient weather particles — opt-in via sky-peek. Renders behind Mochi. */}
                <WeatherFx size={210} />
                <Avatar
                    mood={mood.displayMood}
                    size={210}
                    onTap={mood.handleAvatarTap}
                    style={settings?.avatar_style || "feminine"}
                    skin={skin}
                    animateSkinIn={animateSkinIn}
                    momentum={getMochiMomentum(settings?.meter_value || 0)}
                    boost={fireDance ? 0.2 : 0}
                    idleGaze={idleGaze}
                    accessory={activeAccessory(settings)}
                    pin={!!settings?.pin_equipped}
                />
            </div>
            <div className="-mt-4 w-full flex justify-center">
                <SpeechBubble message={mood.bubbleMsg} loading={mood.bubbleLoading} />
            </div>
            <div className="mt-1 w-full px-2">
                <CoverPassOffer
                    open={coverOffer.open}
                    message={coverOffer.message}
                    habitTitle={coverOffer.habit?.title}
                    onAccept={onAcceptCover}
                    onDecline={onDeclineCover}
                    onDismiss={onDeclineCover}
                />
            </div>
            <div className="mt-2 flex justify-center">
                <RiceBallButton
                    settings={settings}
                    onSettingsUpdate={(patch) => setSettings((s) => ({ ...(s || {}), ...patch }))}
                    targetRef={avatarRef}
                    onFedLocal={() => mood.nomReact?.()}
                    onLevelChange={({ to }) => { if (to >= 5) onFireDance(); }}
                    onIgnite={() => {
                        onFireDance();
                        mood.forceMoodFor?.("excited", 6000);
                    }}
                />
            </div>
        </div>
    );
}
